module.exports = __webpack_public_path__ + "img/project status 3.e906aa3e.jpg";